/**
 * @module js/AddPartToLibrariesService
 */

export const enableAddButton = (vmo, selectedObj) => {
    const { data, dispatch } = vmo;
    if(selectedObj[0].containerType === 'library' || selectedObj[0].containerType === 'project'){
        data.selectedLibraries = selectedObj;
    }
    if(selectedObj[0].containerType === 'Folder'){
        data.folderId = selectedObj[0].containerId;
    }
    data.enableAddButton = true;
    dispatch({path: 'data', value: {...data}});
};

export default {
    enableAddButton
};
